import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { TableBodyRowComponentProps } from "../tableTypes";

const useStyles = makeStyles<Theme, any>(
  (theme) =>
    createStyles({
      darkRow: {
        backgroundColor: "#f3f3f1",
      },
      lightRow: {
        backgroundColor: theme.colors.tWhite,
      },
    }),

  { name: `Table-${"Standard"}-BodyRow` }
);
const TableBodyRowComponent: React.FC<TableBodyRowComponentProps<object>> = ({
  row,
  rowIndex,
  tableProps,
  config,
  tableId,
}) => {
  const classes = useStyles({});
  const handleOnClick = () => {
    if (!config.getRowOnClick) return;
    config.getRowOnClick(row);
  };
  return (
    <TableRow
      onClick={handleOnClick}
      {...row.getRowProps()}
      {...tableProps?.bodyRow}
      className={config.striped ? (rowIndex % 2 ? classes.darkRow : classes.lightRow) : classes.lightRow}
    >
      {row.cells.map((cell, cellIndex) => {
        const { width, minWidth, maxWidth } = cell.column;
        return (
          <TableCell
            {...cell.getCellProps()}
            {...tableProps?.bodyCell}
            style={
              config.dense
                ? { width, minWidth, maxWidth, fontSize: "14px", padding: "8px 12.5px" }
                : { width, minWidth, maxWidth }
            }
            key={`table-${tableId}-br-${rowIndex}-c${cellIndex}`}
          >
            {cell.render("Cell")}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default TableBodyRowComponent;
